import { createElement } from 'react';

import AssetsImage from '@assets/images/person.png';

import { AppAsset, Images } from './Images';

export const ImagesContainer = () => {
  const images: AppAsset[] = [
    { src: AssetsImage, alt: 'Imagem localizada dentro de src' },
    {
      src: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
      alt: 'Imagem localizada na internet',
    },
    {
      src: `${import.meta.env.BASE_URL}images/person.png`,
      alt: 'Imagem localizada no diretório público',
    },
  ];

  const props = {
    images,
  };

  return createElement(Images, props);
};
